
import Vue from "vue";
import moment from "moment";
import { Line } from "vue-chartjs";

export default Vue.extend({
    extends: Line,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                elements: {
                    line: {
                        fill: true,
                    },
                },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            ticks: {
                                source: "auto",
                            },
                        },
                    ],
                },
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels.map((l) =>
                    moment(new Date(parseInt(l)))
                        .subtract(moment().utcOffset(), "minutes")
                        .toDate()
                        .getTime()
                ),
                datasets: this.datasets,
            };
        },
    },
    mounted() {
        this.renderChart(this.chartdata, this.options);
    },
});
